import { Component, React } from "react";

export class InvoiceTab extends Component {
    render() {
        const {listStatus, onClickTab} =this.props;
        return(
           <>
            {listStatus.map((item,id)=>
                <div key={id} data-index={id} title={item.title} className="invoice-status-container" onClick={onClickTab}>
                    <div  data-index={id} className="horizontal-status">
                    </div>
                    <div title={item.title}  data-index={id} className="invoice-status-list-container">
                        <h1  data-index={id} className="title">{item.title}</h1>
                        <h2  data-index={id} className="details">You have <span>({item.list})</span> {item.title.toLowerCase()} items</h2>
                    </div>
                </div>
            )}  
           </>         
        )
    }
}